import React from 'react';
import imgBanner from '../../assets/images/Group 1171275189.png';
import vectorBanner from '../../assets/images/Vector 32.png';
import imgEllipse from '../../assets/images/Ellipse 33.png'
import { useNavigate } from 'react-router-dom';
import MonBouton from '../Utils/design-system/buttons/MonBouton';
import { TbClick } from "react-icons/tb";
import CardBanner from './cardBanner';
import badge from '../../assets/images/fluent-emoji-flat_military-medal.svg'
import { FiBarChart2 } from "react-icons/fi";
import cardPayement from "../../assets/images/Frame 45.png"

function Banner() {
  const navigate = useNavigate();
  return (
    <div className="banner w-[94%] flex  justify-between items-center ">
      <div className="w-[45%] max-lg:w-[90%] flex flex-col gap-8">
        <h1
          className={`text-[3.6rem] max-lg:text-3xl !font-inter max-sm:text-2.5xl text-noirel 
           leading-[80px] font-[700] max-xl:leading-[50px] max-xl:text-5xl max-sm:tracking-wider pb-0 md:pb-4`}
        >
          <p className='text-nowrap'>Transformez votre</p>
          <p>
            <span className="text-orange">vision</span> en{" "}
            <span className="text-vr">réalité</span>
          </p>
          <p>simplement</p>
        </h1>
        <div className='text-center'>
          <img src={vectorBanner} alt="vector" className="w-[85%]" />
        </div>
        <div className="flex flex-col gap-9">
          <p className="font-mandali text-[18px] text-noir max-xl:text-sm max-lg:text-lg">
            Simplifiez la gestion de vos projets et accédez à des talents
            qualifiés à moindre coût !
          </p>
          {/* <div className="flex justify-center items-center w-full">
            <div className="md:w-1/2 w-full text-nowrap md:text-wrap">
              <MonBouton
                children={"Soumettre un projet !"}
                couleurFond={"bg-orange"}
                bordure={
                  " border py-2 max-sm:py-1 max-sm:px-1 max-xl:text-xs max-lg:text-[8px] max-lg:p-1 rounded-full justify-center text-base font-inter text-white gap-2 font-sans font-medium max-sm:text-xs md:w-11/12 "
                }
                action={() => navigate("soumettre-projet")}
                type={"button"}
              />
            </div>
            <div className=" md:w-1/2 w-full text-nowrap  md:text-wrap">
              <MonBouton
                children={"Rejoindre un projet"}
                couleurFond={"bg-transparent"}
                bordure={
                  "px-3 border-2 border-black/15 max-sm:py-1 max-sm:px-1 max-xl:text-xs max-lg:text-[8px] max-lg:justify-start max-lg:gap-1 rounded-full justify-center text-base font-inter text-noirel  font-sans font-medium max-sm:text-xs "
                }
                icone={
                  <TbClick
                    size={40}
                    className="text-noirel stroke-current stroke-1 max-xl:size-8 max-lg:size-4 animate-pulse"
                  />
                }
                action={() => navigate("projets")}
                type={"button"}
              />
            </div>
          </div> */}
          <div className="flex flex-wrap justify-center items-center w-full gap-4">
            {/* Bouton Soumettre un projet */}
            <div className="flex-1 min-w-[150px] max-w-[300px] flex justify-center">
              <MonBouton
                children="Soumettre un projet !"
                couleurFond="bg-orange"
                bordure="w-full py-2.5 px-3 text-xs sm:text-sm md:text-base rounded-full text-white font-medium shadow-md flex justify-center items-center whitespace-nowrap"
                action={() => navigate("soumettre-projet")}
                type="button"
              />
            </div>

            {/* Bouton Rejoindre un projet */}
            <div className="flex-1 min-w-[150px] max-w-[300px] flex justify-center">
              <MonBouton
                children="Rejoindre un projet"
                couleurFond="bg-transparent"
                bordure="w-full py-2 px-3 text-xs sm:text-sm md:text-base rounded-full text-black font-medium border border-black shadow-md flex justify-center items-center whitespace-nowrap"
                icone={
                  <TbClick
                    size={20}
                    className="ml-2 text-black stroke-current animate-pulse"
                  />
                }
                action={() => navigate("projets")}
                type="button"
              />
            </div>
          </div>

        </div>
      </div>
      <div className=" hidden w-[54%] max-lg:w-[58%]  md:flex justify-center relative">
        <CardBanner
          title={"Gain total"}
          price={"75.000FCFA"}
          infos={"flex-col"}
          button={true}
          position={
            "absolute top-[5%] left-[-2%] md:w-[38%]   px-4 py-4 max-lg:py-2 max-lg:px-2 animate-custom-bounce"
          }
          border={"border-b border-whiteclear"}
        />
        <CardBanner
          title={"Développeur web"}
          price={"Mamadou Barry"}
          profile={imgEllipse}
          position={
            "absolute top-[70px] md:top-[25%] right-[5%] md:w-[38%] px-4 py-2 max-lg:py-2 max-lg:px-2 animate-custom-bounce"
          }
          icon={
            <img
              src={badge}
              alt="img"
              className="w-5 h-5 max-lg:w-3 max-lg:h-3"
            />
          }
          infos={"flex-col-reverse"}
          place={"bg-vrt p-2 rounded-full max-lg:p-1"}
        />
        <img
          src={cardPayement}
          className="absolute top-[60%] right-[8%] w-[20%] animate-custom-bounce-top"
        />
        <CardBanner
          title={"Revenu total"}
          price={"100.000FCFA"}
          infos={"flex-col"}
          position={
            "absolute top-[75%] left-[10%] md:w-[22%] py-3 px-3 max-lg:p-2 animate-custom-bounce-top"
          }
          border={"!items-end"}
          icon={<FiBarChart2 className="text-vrt" size={18} />}
          place={"flex flex-col items-end w-[30%]"}
        />
        <img src={imgBanner} alt="img" className="md:w-[72%] w-full object-contain" />
      </div>
    </div>
  );
}

export default Banner